import { ATTEND_INSURANCE_COOPERATION_USER_DATA_REQUEST, SIGN_IN_WITH_OTP_AND_INSURANCE_NUMBER_REQUEST } from 'redux/actions';
import { arrayContains } from 'utils';

export const isOtpLoadingByHealthInsurance = (state) =>
  arrayContains(state.entities.users.openRequests, [
    SIGN_IN_WITH_OTP_AND_INSURANCE_NUMBER_REQUEST,
    ATTEND_INSURANCE_COOPERATION_USER_DATA_REQUEST
  ]);
